"use strict";

import axios from "axios";
import qs from "qs";

import store from "../store";
import router from "../router";

import { useError, useRequest, useResponse } from "../api-map";

axios.interceptors.request.use(
  config => {
    config = useRequest(config);
    // loading
    if (store.state.authentication && store.state.authentication.token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${store.state.authentication.token}`
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    response = useResponse(response);
    return response;
  },
  error => {
    error = useError(error);
    return Promise.reject(error.response);
  }
);

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (
    response &&
    (response.status === 200 ||
      response.status === 201 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    return response.data;
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: "网络异常"
  };
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === 404) {
    console.log(res.msg);
  }
  if (res.status === 500) {
    console.log(res.msg);
  }
  return res;
}

export const post = (url, data) => {
  return axios({
    method: "post",
    baseURL: process.env.VUE_APP_API_BASE_URL || "",
    url,
    data,
    timeout: 10000,
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(response => {
      return checkStatus(response);
    })
    .then(res => {
      return checkCode(res);
    });
};
export const get = (url, params) => {
  return axios({
    method: "get",
    baseURL: process.env.VUE_APP_API_BASE_URL || "",
    url,
    params, // get 请求时带的参数
    timeout: 10000,
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(response => {
      return checkStatus(response);
    })
    .then(res => {
      return checkCode(res);
    });
};

let config = {
  baseURL: process.env.VUE_APP_API_BASE_URL || "",
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  paramsSerializer: function(params) {
    return qs.stringify(params, { arrayFormat: "indices", allowDots: true });
  }
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    useRequest(config);
    if (store.state.authentication && store.state.authentication.token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${store.state.authentication.token}`
      };
    }

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    response = useResponse(response);
    // Do something with response data
    if (response.headers["content-type"] == "application/x-download") {
      return response;
    }

    return response.data;
  },
  async function(error) {
    error = useError(error);
    // Do something with response error
    if (error.response.status && error.response.status === 401) {
      await store.dispatch("deleteAuthentication");
    }

    return Promise.reject(error);
  }
);

window.axios = _axios;

export const request = _axios;



// WEBPACK FOOTER //
// ./src/http/http.js